export class LeftMenuItem {   
    name: string;
    routerLink: string;
    image: string;
    
}



// WEBPACK FOOTER //
// ./src/app/_models/left-menu-item.model.ts